import { BANNER_SET_BANNERS } from "../actions/banner.actions";

export interface Banner {
    id: number;
    html_text: string;
    config: {
        icon: "success" | "info" | "warning" | "error";
        color: string;
        button?: { url: string; label: string };
    };
}

interface BannerState {
    banners: Banner[];
}

const initialState: BannerState = {
    banners: [],
};

export const bannerReducer = (state = initialState, action: any): BannerState => {
    switch (action.type) {
        case BANNER_SET_BANNERS:
            return { ...state, banners: action.payload };
        default:
            return state;
    }
};
